import type { FetchState } from "../lib/api";
import PageShell from "./PageShell";

/**
 * What a public page shows before (or instead of) its content: the brief
 * loading beat, a "no such thing" page, and the couldn't-reach-the-server
 * fallback. Keeps the three shaped like the page they stand in for.
 */
const PageStatus = ({
  state,
  missingTitle,
  missingBody,
  eyebrow,
  backHref = "/",
  backLabel = "Back to StreamLover",
}: {
  state: FetchState<unknown>;
  missingTitle: string;
  missingBody: string;
  /** Small line above the headline, e.g. the address that didn't resolve. */
  eyebrow?: string;
  backHref?: string;
  backLabel?: string;
}) => {
  if (state.kind === "loading") {
    return (
      <PageShell>
        <main className="station">
          <p className="station__quiet mono">Tuning in…</p>
        </main>
      </PageShell>
    );
  }

  const missing = state.kind === "missing";
  return (
    <PageShell>
      <main className="station">
        {eyebrow && (
          <p className="eyebrow">
            <span className="blip" /> {eyebrow}
          </p>
        )}
        <h1 className="station__name">
          {missing ? missingTitle : "Couldn't load this page."}
        </h1>
        <p className="station__sub">
          {missing
            ? missingBody
            : "We couldn't reach the server. Try again in a moment."}
        </p>
        <a className="btn" href={backHref}>
          {backLabel}
        </a>
      </main>
    </PageShell>
  );
};

export default PageStatus;
